

































import Vue from 'vue';
import MStoreForm from '@/components/shared/MStoreForm.vue';

export default Vue.extend({
  name: 'MStoreDeleteConfirmation',
  data() {
    return {
      confirmedEntityNameToDelete: ''
    };
  },
  props: {
    canCopyPaste: {
      type: Boolean,
      default: true
    },
    entityNameToDelete: {
      type: String,
      required: true
    },
    entityTypeToDelete: {
      type: String,
      required: true
    },
    entityDescriptionToDelete: {
      type: String,
      required: true
    },
    additionalEntityInformation: {
      type: String
    },
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onDelete() {
      this.$emit('on-delete-confirmation');
    },
    onCancel() {
      this.$emit('on-cancel-delete-confirmation');
    }
  },
  computed: {
    isConfirmedEntityNameToDeleteValid(this: any) {
      return this.confirmedEntityNameToDelete === this.entityNameToDelete;
    },
    eventHandlers(this: any) {
      return !this.canCopyPaste
        ? {
            contextmenu: ($event: Event) => $event.preventDefault(),
            copy: ($event: Event) => $event.preventDefault(),
            paste: ($event: Event) => $event.preventDefault()
          }
        : {};
    }
  },
  components: { MStoreForm }
});
